var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('index-header'),_c('el-container',[_c('index-aside'),_c('index-main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }